import {request} from '../lib/tycho';

export function reinvite(inviteId) {
  return dispatch => {
    dispatch({type: 'REINVITE_REQUEST'});
    request(`pub/invites/${inviteId}/reinvite`, {method: 'POST'})
      .then(() => dispatch({type: 'REINVITE_RECEIVE'}))
      .then(() => dispatch({
        type: 'ALERT_DIALOG_OPEN',
        payload: {
          type: 'dialog',
          header: 'It\'s on the way. Check your inbox.',
          template: 'invite_sent_dialog'
        }
      }))
      .catch(err => {
        if (err.res.status === 429) {
          dispatch({
            type: 'ALERT_BAR_SHOW',
            payload: {
              type: 'warning',
              message: 'Resent email too recently, please try again later.',
            }
          });
        }
        if (err.res.status === 404) {
          dispatch({
            type: 'ALERT_DIALOG_OPEN',
            payload: {
              type: 'dialog',
              header: 'Access to this Vizia Deck has been temporarily been suspended',
              template: 'invite_suspended_dialog'
            }
          });
        }
        dispatch({type: 'REINVITE_RECEIVE'});
      });
  };
}

export const getObfuscatedEmail = invite_id => dispatch => {
  const req = path => request(path, {
    method: 'GET',
  });
  dispatch({type: 'REINVITE_OBFUSCATED_EMAIL_REQUEST'});
  return req(`/pub/invites/${invite_id}/email`)
    .then(res => res.json())
    .then(email => dispatch({type: 'REINVITE_OBFUSCATED_EMAIL_RECEIVE', payload: email}));
};
